export default "__VITE_ASSET__60e66d78__"